import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import Breadcrums from "../../common/breadcrumbs";
import $ from "jquery";
import {
  SWAL_SETTINGS,
  THEME_COLORS,
} from "../../../../utils/Constants";
import {
  capitalizeFirstLetter,
  handleServerValidations,
  TrimText,
} from "../../../../utils/commonfunction";
import { Tooltip, Whisper, Placeholder } from "rsuite";
import {
  LicenseChangeList,
  ChangeMassageLicenseVerification,
  ChangeInjectionLicenseVerification,
  ChangeProfileLicenseVerification,
} from "../../services/babeAssociate.service";
import { usePermission } from "../../../../utils/commonfunction";

const LicenseChangedAssociateList = () => {
  const { t } = useTranslation();
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { can } = usePermission();

  const [list, setList] = useState([]);
  const [statsupdate, setStatusUpdate] = useState("false");
  const [datalength, setDataLength] = useState("");
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [search, setSearch] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const [statusUpdated, setStatusUpdated] = useState(false);

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("Babe Associates"), url: "/admin/babe-associate/list/1" },
    { title: "License Changes", url: "" },
  ];

  const statusNewBadgeMap = {
    NEW: "badge-warning-light",
    PENDING: "badge-warning-light",
    VERIFIED: "badge-success-light",
    REJECTED: "badge-danger-light",
  };

  useEffect(() => {
    const getData = setTimeout(() => {
      setLoader(true);
      const formData = new FormData();
      formData.append("page", params.pgno);
      formData.append("per_page", itemperpage);
      formData.append("sort", JSON.stringify(sorting));
      formData.append("search", JSON.stringify(search));
      formData.append("global_search", globalsearch);
      LicenseChangeList(formData)
        .then((data) => {
          setDataLength(data.data.total_records);
          setList(data?.data?.list || []);
          setPage(data?.data?.page || 1);
          setLoader(false);
        })
        .catch((error) => {
          console.log("error ====> ", error);
          setLoader(false);
        });
    }, 300);
    return () => clearTimeout(getData);
  }, [location, statsupdate, sorting, search, globalsearch, itemperpage, params.pgno, statusUpdated]);

  const handleSort = (e, column) => {
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    setSearch({});
    $("#defaultstatus")[0] && ($("#defaultstatus")[0].selectedIndex = 0);
  };

  const viewfunction = (row) => {
    navigate(`/admin/babe-associate/view/${row._id}`);
  };

  const changeMassageLicenseStatus = (_id, status) => {
    const textMap = {
      VERIFIED: t("label_license_mark_verified"),
      PENDING: "Mark as Pending?",
      REJECTED: t("label_license_mark_unverified"),
    };
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: textMap[status] || textMap.VERIFIED,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: THEME_COLORS.ADMIN_PRIMARY,
      cancelButtonColor: "#000",
      confirmButtonText: status === "VERIFIED" ? t("label_verified") : status === "PENDING" ? "Pending" : t("label_unverified"),
      cancelButtonText: t("btn_cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        ChangeMassageLicenseVerification({ _id, associate_massage_license_verification: status })
          .then((response) => {
            if (response.success) {
              Swal.fire({ icon: "success", text: response.message, ...SWAL_SETTINGS });
              setStatusUpdated(!statusUpdated);
            } else {
              Swal.fire({ icon: "error", text: handleServerValidations(response), ...SWAL_SETTINGS });
            }
          })
          .catch((error) => console.log("error", error));
      }
    });
  };

  const changeInjectionLicenseStatus = (_id, status) => {
    const textMap = {
      VERIFIED: t("label_license_mark_verified"),
      PENDING: "Mark as Pending?",
      REJECTED: t("label_license_mark_unverified"),
    };
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: textMap[status] || textMap.VERIFIED,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: THEME_COLORS.ADMIN_PRIMARY,
      cancelButtonColor: "#000",
      confirmButtonText: status === "VERIFIED" ? t("label_verified") : status === "PENDING" ? "Pending" : t("label_unverified"),
      cancelButtonText: t("btn_cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        ChangeInjectionLicenseVerification({ _id, associate_injection_license_verification: status })
          .then((response) => {
            if (response.success) {
              Swal.fire({ icon: "success", text: response.message, ...SWAL_SETTINGS });
              setStatusUpdated(!statusUpdated);
            } else {
              Swal.fire({ icon: "error", text: handleServerValidations(response), ...SWAL_SETTINGS });
            }
          })
          .catch((error) => console.log("error", error));
      }
    });
  };

  const changeLicenseStatus = (_id, status) => {
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: status ? t("label_license_mark_verified") : t("label_license_mark_unverified"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: THEME_COLORS.ADMIN_PRIMARY,
      cancelButtonColor: "#000",
      confirmButtonText: status ? t("label_verified") : t("label_unverified"),
      cancelButtonText: t("btn_cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        ChangeProfileLicenseVerification({ _id, associate_profile_verification_stauts: status })
          .then((response) => {
            if (response.success) {
              Swal.fire({ icon: "success", text: response.message, ...SWAL_SETTINGS });
              setStatusUpdated(!statusUpdated);
            } else {
              Swal.fire({ icon: "error", text: handleServerValidations(response), ...SWAL_SETTINGS });
            }
          })
          .catch((error) => console.log("error", error));
      }
    });
  };

  const formatDateWithTime = (createdAt) => {
    const date = new Date(createdAt);
    return `${date.toLocaleDateString()} ${date.toLocaleTimeString().substring(0, 5)}`;
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">
                <i className="ri-file-list-3-line me-2" style={{ color: "#f59f00" }}></i>
                License Change Requests
                <small className="text-muted ms-2" style={{ fontSize: "13px", fontWeight: "normal" }}>
                  — Associates who updated their RN or Massage license details
                </small>
              </h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("input_placeholder_search")}
                      onChange={(e) => setGlobalSearch(e.target.value)}
                    />
                  </div>
                </div>
                <button
                  type="reset"
                  onClick={resetFilter}
                  className="btn ripple btn-main-primary signbtn"
                >
                  {t("btn_reset_filter")}
                </button>
              </div>
            </div>

            {loader ? (
              <Placeholder.Paragraph
                className="w-100 admin-placeholder"
                rowHeight={30}
                rowSpacing={5}
                active={true}
                rows={7}
              />
            ) : (
              <>
                <div className="table-responsive min-h-400">
                  <table className="table table-bordered card-table border-top text-nowrap w-100">
                    <thead>
                      <tr>
                        <th>{t("list_heading_sno")}</th>
                        <th>
                          <div className="sorting_column">
                            <span>{t("label_name")}</span>
                            <Sorting sort={sorting} handleSort={handleSort} column="name" />
                          </div>
                        </th>
                        <th>{t("label_email")}</th>
                        <th>{t("label_phone_number")}</th>
                        <th className="status_head">
                          Admin Verification
                        </th>
                        <th className="status_head">
                          <div className="sorting_column">
                            <span>Massage License</span>
                            <Sorting sort={sorting} handleSort={handleSort} column="associate_massage_license_status" />
                          </div>
                        </th>
                        <th className="status_head">
                          <div className="sorting_column">
                            <span>RN License</span>
                            <Sorting sort={sorting} handleSort={handleSort} column="associate_license_status" />
                          </div>
                        </th>
                        <th className="created_head">{t("list_heading_created_date")}</th>
                        {can("/admin/babe-associate/view") && (
                          <th className="action_head">{t("list_heading_action")}</th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {list.length ? (
                        list.map((row, i) => (
                          <tr key={i} style={{ background: "#fff8e1", borderLeft: "3px solid #f59f00" }}>
                            <td>{(page - 1) * itemperpage + i + 1}</td>
                            <td>
                              {row?.name ? (
                                <div className="d-flex align-items-center gap-1">
                                  <Whisper
                                    placement="top"
                                    trigger="hover"
                                    speaker={<Tooltip>License change — needs review</Tooltip>}
                                  >
                                    <i
                                      className="ri-error-warning-fill"
                                      style={{ color: "#f59f00", fontSize: "15px", flexShrink: 0 }}
                                    ></i>
                                  </Whisper>
                                  {TrimText(capitalizeFirstLetter(row.name), 20)}
                                </div>
                              ) : (
                                "N/A"
                              )}
                            </td>
                            <td>{row?.email || "N/A"}</td>
                            <td>{row?.phone_number || "N/A"}</td>

                            {/* Admin / Profile Verification */}
                            <td>
                              <div style={{ display: "flex", alignItems: "center", marginTop: "5px" }}>
                                <Whisper placement="top" trigger="hover" speaker={<Tooltip>Toggle Admin Verification</Tooltip>}>
                                  <i
                                    className="ri-user-fill me-1"
                                    style={{ color: "#d4adf5", fontSize: "18px", cursor: "pointer", marginLeft: "6px" }}
                                    onClick={() => changeLicenseStatus(row._id, !row.associate_profile_verification)}
                                  ></i>
                                </Whisper>
                                <button
                                  className={`badge badge-pill ${row?.associate_profile_verification ? "badge-success-light" : "badge-danger-light"}`}
                                  style={{ border: "none", cursor: "pointer" }}
                                  onClick={() => changeLicenseStatus(row._id, !row.associate_profile_verification)}
                                >
                                  {row?.associate_profile_verification ? t("VERIFIED") : t("NOT VERIFIED")}
                                </button>
                              </div>
                            </td>

                            {/* Massage License */}
                            <td>
                              <div style={{ display: "flex", alignItems: "center", marginTop: "5px" }}>
                                <div className="mlAction">
                                  <Whisper
                                    placement="top"
                                    trigger="hover"
                                    speaker={<Tooltip>Change Massage License Status</Tooltip>}
                                  >
                                    <span
                                      className="dropdown-toggle no-after"
                                      data-bs-toggle={
                                        row?.associate_preferred_services?.some((s) =>
                                          s.subcategorydata?.some((sub) =>
                                            sub.title?.toLowerCase().includes("massage")
                                          )
                                        )
                                          ? "dropdown"
                                          : undefined
                                      }
                                      aria-expanded="false"
                                      style={{
                                        cursor: row?.associate_preferred_services?.some((s) =>
                                          s.subcategorydata?.some((sub) =>
                                            sub.title?.toLowerCase().includes("massage")
                                          )
                                        )
                                          ? "pointer"
                                          : "not-allowed",
                                      }}
                                    >
                                      <i
                                        className="ri-settings-5-fill me-1"
                                        style={{
                                          color: row?.associate_preferred_services?.some((s) =>
                                            s.subcategorydata?.some((sub) =>
                                              sub.title?.toLowerCase().includes("massage")
                                            )
                                          )
                                            ? "#000000"
                                            : "#ccc",
                                          fontSize: "18px",
                                          marginLeft: "6px",
                                        }}
                                      ></i>
                                    </span>
                                  </Whisper>
                                  {row?.associate_preferred_services?.some((s) =>
                                    s.subcategorydata?.some((sub) =>
                                      sub.title?.toLowerCase().includes("massage")
                                    )
                                  ) && (
                                    <ul className="dropdown-menu">
                                      {row?.associate_massage_license_status !== "VERIFIED" && (
                                        <li>
                                          <button
                                            className="dropdown-item"
                                            onClick={() => changeMassageLicenseStatus(row._id, "VERIFIED")}
                                          >
                                            Verified
                                          </button>
                                        </li>
                                      )}
                                      {row?.associate_massage_license_status !== "PENDING" && (
                                        <li>
                                          <button
                                            className="dropdown-item"
                                            onClick={() => changeMassageLicenseStatus(row._id, "PENDING")}
                                          >
                                            Pending
                                          </button>
                                        </li>
                                      )}
                                      {row?.associate_massage_license_status !== "REJECTED" && (
                                        <li>
                                          <button
                                            className="dropdown-item"
                                            onClick={() => changeMassageLicenseStatus(row._id, "REJECTED")}
                                          >
                                            Rejected
                                          </button>
                                        </li>
                                      )}
                                    </ul>
                                  )}
                                </div>
                                <span
                                  className={`badge badge-pill ${
                                    row?.associate_preferred_services?.some((s) =>
                                      s.subcategorydata?.some((sub) =>
                                        sub.title?.toLowerCase().includes("massage")
                                      )
                                    )
                                      ? statusNewBadgeMap[row?.associate_massage_license_status] || "badge-warning-light"
                                      : "badge-danger-light"
                                  }`}
                                >
                                  {row?.associate_preferred_services?.some((s) =>
                                    s.subcategorydata?.some((sub) =>
                                      sub.title?.toLowerCase().includes("massage")
                                    )
                                  )
                                    ? row?.associate_massage_license_status === "VERIFIED"
                                      ? t("VERIFIED")
                                      : row?.associate_massage_license_status === "REJECTED"
                                      ? t("REJECTED")
                                      : row?.associate_massage_license_status === "NEW"
                                      ? t("NEW")
                                      : t("PENDING")
                                    : "Not Applicable"}
                                </span>
                              </div>
                            </td>

                            {/* RN / Injection License */}
                            <td>
                              <div style={{ display: "flex", alignItems: "center", marginTop: "5px" }}>
                                <div className="mlAction">
                                  <Whisper
                                    placement="top"
                                    trigger="hover"
                                    speaker={<Tooltip>Change RN License Status</Tooltip>}
                                  >
                                    <span
                                      className="dropdown-toggle no-after"
                                      data-bs-toggle={
                                        row?.associate_preferred_services?.some((s) =>
                                          s.title?.toLowerCase().includes("injection concierge")
                                        )
                                          ? "dropdown"
                                          : undefined
                                      }
                                      aria-expanded="false"
                                      style={{
                                        cursor: row?.associate_preferred_services?.some((s) =>
                                          s.title?.toLowerCase().includes("injection concierge")
                                        )
                                          ? "pointer"
                                          : "not-allowed",
                                      }}
                                    >
                                      <i
                                        className="ri-settings-5-fill me-1"
                                        style={{
                                          color: row?.associate_preferred_services?.some((s) =>
                                            s.title?.toLowerCase().includes("injection concierge")
                                          )
                                            ? "#000000"
                                            : "#ccc",
                                          fontSize: "18px",
                                          marginLeft: "6px",
                                        }}
                                      ></i>
                                    </span>
                                  </Whisper>
                                  {row?.associate_preferred_services?.some((s) =>
                                    s.title?.toLowerCase().includes("injection concierge")
                                  ) && (
                                    <ul className="dropdown-menu">
                                      {row?.associate_license_status !== "VERIFIED" && (
                                        <li>
                                          <button
                                            className="dropdown-item"
                                            onClick={() => changeInjectionLicenseStatus(row._id, "VERIFIED")}
                                          >
                                            Verified
                                          </button>
                                        </li>
                                      )}
                                      {row?.associate_license_status !== "PENDING" && (
                                        <li>
                                          <button
                                            className="dropdown-item"
                                            onClick={() => changeInjectionLicenseStatus(row._id, "PENDING")}
                                          >
                                            Pending
                                          </button>
                                        </li>
                                      )}
                                      {row?.associate_license_status !== "REJECTED" && (
                                        <li>
                                          <button
                                            className="dropdown-item"
                                            onClick={() => changeInjectionLicenseStatus(row._id, "REJECTED")}
                                          >
                                            Rejected
                                          </button>
                                        </li>
                                      )}
                                    </ul>
                                  )}
                                </div>
                                <span
                                  className={`badge badge-pill ${
                                    row?.associate_preferred_services?.some((s) =>
                                      s.title?.toLowerCase().includes("injection concierge")
                                    )
                                      ? statusNewBadgeMap[row?.associate_license_status] || "badge-warning-light"
                                      : "badge-danger-light"
                                  }`}
                                >
                                  {row?.associate_preferred_services?.some((s) =>
                                    s.title?.toLowerCase().includes("injection concierge")
                                  )
                                    ? row?.associate_license_status === "VERIFIED"
                                      ? t("VERIFIED")
                                      : row?.associate_license_status === "REJECTED"
                                      ? t("REJECTED")
                                      : row?.associate_license_status === "NEW"
                                      ? t("NEW")
                                      : t("PENDING")
                                    : "Not Applicable"}
                                </span>
                              </div>
                            </td>

                            <td>{row?.createdAt ? formatDateWithTime(row.createdAt) : "N/A"}</td>

                            {can("/admin/babe-associate/view") && (
                              <td>
                                <div className="btn-toolbar table-actions" role="toolbar">
                                  <div className="btn-group btn-group-sm" role="group">
                                    <Whisper
                                      placement="top"
                                      trigger="hover"
                                      speaker={<Tooltip style={{ fontWeight: "bold" }}>View</Tooltip>}
                                    >
                                      <button
                                        type="button"
                                        className="btn view"
                                        onClick={() => viewfunction(row)}
                                      >
                                        <i className="ri-eye-fill"></i>
                                      </button>
                                    </Whisper>
                                  </div>
                                </div>
                              </td>
                            )}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={9} className="text-center">
                            {t("msg_no_records")}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <div id="example1_info" role="status" aria-live="polite">
                  <b>
                    {t("msg_total_records")} : {datalength || "0"}
                  </b>
                </div>

                {datalength && datalength > 0 ? (
                  <CustomPagination
                    datalength={datalength}
                    itemperpage={itemperpage}
                    currentPage={page}
                    setPage={setPage}
                    pageRoute={[
                      {
                        name: "LicenseChanges",
                        path: "/admin/license-changes/list",
                      },
                    ]}
                  />
                ) : null}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default LicenseChangedAssociateList;
